function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
var _React_PureComponent;
class Tabs extends (_React_PureComponent = React.PureComponent) {
    onClick(evt, item) {
        evt.preventDefault();
        this.props.action(item);
    }
    renderTab(item, style) {
        if (!item) {
            return null;
        }
        const { activeItem, errors, modified } = this.props;
        return /*#__PURE__*/ _jsx("li", {
            className: cn('tab', {
                'tab--active': item === activeItem,
                'tab--error': errors && errors[item]
            }),
            style: style,
            children: /*#__PURE__*/ _jsxs("a", {
                href: "",
                onClick: (evt)=>this.onClick(evt, item),
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, this.props.messages[item])),
                    modified && modified[item] && /*#__PURE__*/ _jsx("span", {
                        children: "*"
                    })
                ]
            })
        }, item);
    }
    render() {
        const { items } = this.props;
        const maxWidth = `${100 / items.length}%`;
        const style = {
            flex: `0 0 ${maxWidth}`,
            maxWidth
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "tabs",
            children: map(items, (item)=>this.renderTab(item, style))
        });
    }
}
_define_property(Tabs, "propTypes", {
    // Explicit props
    activeItem: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    messages: PropTypes.object.isRequired,
    errors: PropTypes.object,
    modified: PropTypes.object,
    // Explicit actions
    action: PropTypes.func.isRequired
});
export default Tabs;
